// Application Configuration
// This file contains all configurable settings for the BTMS application

export const appConfig = {
  // Website/Branding Settings
  website: {
    title: 'BTMS',
    subtitle: 'Transport Management System with GPS Tracking',
    icon: '/media/tracking.png',
    logo: 'BTMS',
    colors: {
      primary: '#03193b',
      secondary: '#1F1F1F',
      accent: '#D98324'
    }
  },

  // Application Settings
  app: {
    name: 'BTMS',
    version: '1.0.0',
    description: 'Transport Management System with GPS Tracking capabilities',
    author: 'TMS Development Team'
  },

  // API Configuration
  api: {
    baseUrl: '',
    timeout: 10000
  },

  // Feature Flags
  features: {
    enableOrderTracking: true,
    enableGPS: true,
    enableReports: true,
    enableSettings: true
  },

  // UI Configuration
  ui: {
    theme: 'light',
    sidebarCollapsed: false,
    itemsPerPage: 10,
    enableAnimations: true
  },

  // Development Settings
  dev: {
    enableDevTools: true,
    logLevel: 'debug'
  }
}

// Environment-specific overrides
const envOverrides = {
  development: {
    dev: {
      enableDevTools: true,
      logLevel: 'debug'
    }
  },

  production: {
    dev: {
      enableDevTools: false,
      logLevel: 'error'
    }
  },

  staging: {
    dev: {
      enableDevTools: true,
      logLevel: 'warn'
    }
  }
}

/**
 * Factory untuk membuat config final dengan env yang disuntikkan dari Vite (node) atau import.meta.env (browser).
 * @param {Record<string,string>} rawEnv
 */
export function createConfig(rawEnv) {
  const env = (rawEnv && typeof rawEnv === 'object')
    ? rawEnv
    : (typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {});

  const currentEnv =
    env.VITE_APP_ENV || env.MODE || env.VITE_APP_MODE || env.NODE_ENV || 'development';

  const config = {
    ...appConfig,
    ...envOverrides[currentEnv],
    website: { ...appConfig.website, ...envOverrides[currentEnv]?.website },
    app:     { ...appConfig.app,     ...envOverrides[currentEnv]?.app },
    api:     { ...appConfig.api,     ...envOverrides[currentEnv]?.api },
    features:{ ...appConfig.features, ...envOverrides[currentEnv]?.features },
    ui:      { ...appConfig.ui,      ...envOverrides[currentEnv]?.ui },
    dev:     { ...appConfig.dev,     ...envOverrides[currentEnv]?.dev },
  };

  const derivedBaseUrl = env.VITE_API_BASE_URL || env.VITE_APP_API_BASE_URL;
  config.api.baseUrl = derivedBaseUrl || config.api.baseUrl || 'http://localhost:3000';

  const getConfig = (path) => path.split('.').reduce((o,k)=>o?.[k], config);
  const setConfig = (path, value) => {
    const keys = path.split('.'); const last = keys.pop();
    const target = keys.reduce((o,k)=>(o[k]=o[k]||{}), config);
    target[last] = value;
  };

  return {
    config,
    websiteConfig: config.website,
    appConfigData: config.app,
    apiConfig: config.api,
    featuresConfig: config.features,
    uiConfig: config.ui,
    devConfig: config.dev,
    getConfig, setConfig
  };
}

// ====== Jalur khusus browser (runtime) ======
export const getClientConfig = () => createConfig(
  (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {}
);

// Default export: pakai jalur browser saat diimport dari client
const __default = getClientConfig().config;
export default __default;

// Named exports untuk client
export const {
  config,
  websiteConfig,
  appConfigData,
  apiConfig,
  featuresConfig,
  uiConfig,
  devConfig,
  getConfig,
  setConfig
} = getClientConfig();